import * as React from 'react';
import { ComponentType } from 'react';
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import ReactTable, { RowInfo } from 'react-table';
import { bindActionCreators } from "redux";
import { InlineLoading } from 'src/components/common';
import { Link } from 'src/components/routing';
import { PAGE_SIZE_OPTIONS } from 'src/constants/reactTableConstants';
import { CommitteeRegularInviteesBreadcrumbs } from 'src/helpers/breadcrumbHelper';
import RouterHoc, { IRouterActions, IRouterProps } from 'src/hoc/RouterHoc';
import * as CommitteeRegularInviteeActions from '../../../actions/committeeRegularInvitee';
import * as CommitteeActions from '../../../actions/committees';
import * as NavigationActions from '../../../actions/navigation';
import * as PagingActions from '../../../actions/pages/pagingPage';
import { RestrictedLayout } from "../../../components/layouts/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { CommitteeSubMenu } from '../../../helpers/subMenuHelper';
import { IFormFilter, ITmdState } from "../../../reducers/index";

import './CommitteeRegularInviteesPage.scss';

interface ICommitteeRegularInviteesPageParams {
    committeeId: number;
}

interface ICommitteeRegularInviteesPageProps extends IRouterProps<ICommitteeRegularInviteesPageParams> {

    committeeId: number;

    // From state
    formFilter: IFormFilter;
    committee: Dtos.Committee;
    committeeRegularInvitees: Dtos.CommitteeRegularInvitee[] | undefined;
    lookups: Dtos.Lookup[];

    loadingCommittee: boolean;
    loadCommitteeSuccess: boolean;
    loadCommitteeFailure: boolean;

    loadingCommitteeRegularInvitees: boolean;
    loadCommitteeRegularInviteesSuccess: boolean;
    loadCommitteeRegularInviteesFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];

    pageSize: number;
}

interface ICommitteeRegularInviteesPageActions extends IRouterActions {
    clearCommitteeRegularInvitees: CommitteeRegularInviteeActions.ICommitteeRegularInviteeClearActionCreator;
    loadCommitteeRegularInvitees: CommitteeRegularInviteeActions.ICommitteeRegularInviteeLoadByCommitteeIdActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

    clearCommittee: CommitteeActions.ICommitteeClearActionCreator;
    loadCommittee: CommitteeActions.ICommitteeLoadByIdActionCreator;

}

type CommitteeRegularInviteesPageProps = ICommitteeRegularInviteesPageProps & ICommitteeRegularInviteesPageActions;

class CommitteeRegularInviteesPage extends React.PureComponent<CommitteeRegularInviteesPageProps, any> {
    initialised: boolean;

    constructor(props: CommitteeRegularInviteesPageProps) {
        super(props);
        this.initialised = false;
        this.clearCommittee = this.clearCommittee.bind(this);
        this.toggleExportMenu = this.toggleExportMenu.bind(this);

        this.state = {
            exportToggle: false
        };
    }

    componentDidMount() {
        const {
            loadCommitteeRegularInvitees,
            committeeId,
            permissions,
            setDrawerItems,
            setBreadcrumbs,
            loadCommittee
        } = this.props;
        

        if (committeeId) {
            setDrawerItems(CommitteeSubMenu(committeeId, permissions));
            setBreadcrumbs(CommitteeRegularInviteesBreadcrumbs(committeeId));
            loadCommittee(committeeId);
            loadCommitteeRegularInvitees(committeeId);
        }
    }

    componentDidUpdate(prevProps: CommitteeRegularInviteesPageProps, _prevState) {
        const {
            committee,
            committeeId,
            loadCommittee,
            setDrawerItems,
            setBreadcrumbs,
            permissions,
            loadCommitteeFailure,
            loadCommitteeRegularInviteesFailure,
            navigate
        } = this.props;

        if (loadCommitteeFailure || loadCommitteeRegularInviteesFailure) {
            navigate(loadCommitteeFailure || loadCommitteeRegularInviteesFailure);
        }

        if (committeeId && committee?.name) {
            setDrawerItems(CommitteeSubMenu(committeeId, permissions));
            setBreadcrumbs(CommitteeRegularInviteesBreadcrumbs(committeeId, committee.name));
        }

        if (committeeId && prevProps.committeeId != committeeId) {
            loadCommittee(committeeId);
        }
    }

    componentWillUnmount() {
        this.clearCommittee();
    }

    clearCommittee() {
        this.props.clearCommittee();
        this.props.clearCommitteeRegularInvitees();
    }

    toggleExportMenu() {
        this.setState({
            exportToggle: !this.state.exportToggle
        });
    }

    showRegularInvitees(): boolean {
        const {
            loadingCommitteeRegularInvitees,
            loadCommitteeRegularInviteesSuccess
        } = this.props

        if (!loadingCommitteeRegularInvitees && loadCommitteeRegularInviteesSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            committeeId,
            committee,
            loadingCommittee,
            loadingCommitteeRegularInvitees,
            permissions
        } = this.props;

        return (
            <RestrictedLayout
                permission={Dtos.Permission.CommitteeRegularInviteeView}
                subMenuTitle={committee ? committee.name : ""}
                subMenuItems={CommitteeSubMenu(committeeId, permissions)}
                loading={loadingCommittee || loadingCommitteeRegularInvitees}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const {
            permissions,
            committeeId
        } = this.props;

        const canCreate = AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeRegularInviteeCreate);

        return (
            <div>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Regular Invitees</h1>
                    </div>
                    <div className="col" style={{ textAlign: 'right' }}>

                        {canCreate && 
                            <>
                                <Link className={"btn btn-primary"} url={`/committees/${committeeId}/regularinvitees/create`}>Create</Link>
                            </>
                        }
                    </div>
                </div>
                {
                    !this.showRegularInvitees() ?
                        <InlineLoading absoluteCenter={true} size={50}/> :
                        null
                }
                {
                    this.showRegularInvitees() ?
                        <div className='card'>
                            <div className="patient-tables">
                                {
                                    this.createTable()
                                }
                            </div>
                        </div> :
                        null
                }
            </div>
        );
    }

    createTable() {

        const {
            committeeId,
            committeeRegularInvitees,
            pageSize,
            setPageSize
        } = this.props

        if (!committeeRegularInvitees || committeeRegularInvitees.length == 0) {
            return (
                <div className='card card-shadow p-3'>
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                        </div>
                        <span>There are currently no regular invitees to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = committeeRegularInvitees.length > pageSize;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={committeeRegularInvitees}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={showPagination ? pageSize : committeeRegularInvitees.length}
                    pageSize={showPagination ? pageSize : committeeRegularInvitees.length}
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no regular invitees to display"
                    resizable={false}
                    onPageSizeChange={val => setPageSize(val)}
                    getTdProps={(state, rowInfo: RowInfo, _column, _instance) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const url = `/committees/${committeeId}/regularinvitees/${rowInfo.original.id}/details`;
                                this.props.navigate(url);

                                if (handleOriginal) {
                                    handleOriginal()
                                }

                            }
                        }
                    }}
                    defaultSorted={[
                        {
                            id: "personnel.display",
                            desc: false
                        }
                    ]}
                    columns={[
                        {
                            id: "id",
                            Header: ' ',
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => <FontAwesomeIcon size='lg' icon={FontAwesomeIcons.Duotone.CALENDARCIRCLEUSER} fixedWidth />
                        },
                        {
                            id: "personnel.displayWithSalutation",
                            Header: 'Name',
                            accessor: 'personnel.displayWithSalutation'
                        },
                        {
                            id: "personnel.display",
                            Header: "",
                            accessor: "personnel.display",
                            maxWidth: 0,
                            Cell: (_props) => <></>
                        }
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: ITmdState, ownProps: CommitteeRegularInviteesPageProps): ICommitteeRegularInviteesPageProps => {

    let committee: Dtos.Committee | undefined = !(state.committees.formData instanceof Array) ? state.committees.formData : undefined;
    let committeeRegularInvitees: Dtos.CommitteeRegularInvitee[] | undefined = (state.committeeRegularInvitee.formData instanceof Array) ? state.committeeRegularInvitee.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: ownProps.location,
        match: ownProps.match,

        committeeRegularInvitees: committeeRegularInvitees,
        formFilter: state.trials.formFilter,
        lookups: state.committeeRegularInvitee.lookups,

        loadingCommitteeRegularInvitees: state.committeeRegularInvitee.loadState && state.committeeRegularInvitee.loadState.status == RequestState.Pending,
        loadCommitteeRegularInviteesSuccess: state.committeeRegularInvitee.loadState && state.committeeRegularInvitee.loadState.status == RequestState.Success,
        loadCommitteeRegularInviteesFailure: state.committeeRegularInvitee.loadState && state.committeeRegularInvitee.loadState.status == RequestState.Failure,

        committeeId: ownProps.match && ownProps.match.params.committeeId?.toString() != "create" ? ownProps.match.params.committeeId : undefined!,
        committee: committee!,

        loadingCommittee: state.committees.loadState && state.committees.loadState.status == RequestState.Pending,
        loadCommitteeSuccess: state.committees.loadState && state.committees.loadState.status == RequestState.Success,
        loadCommitteeFailure: state.committees.loadState && state.committees.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,

        pageSize: state.pagingPage.pageSize
    };
};

const mapDispatchToProps = (dispatch, ownProps: CommitteeRegularInviteesPageProps): ICommitteeRegularInviteesPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadCommitteeRegularInvitees: bindActionCreators(CommitteeRegularInviteeActions.LoadCommitteeRegularInviteeByCommitteeId, dispatch),
        clearCommitteeRegularInvitees: bindActionCreators(CommitteeRegularInviteeActions.Clear, dispatch),

        loadCommittee: bindActionCreators(CommitteeActions.LoadCommitteeById, dispatch),
        clearCommittee: bindActionCreators(CommitteeActions.Clear, dispatch),

        setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch),

        setBreadcrumbs: bindActionCreators(NavigationActions.SetBreadcrumbs, dispatch),
        setDrawerItems: bindActionCreators(NavigationActions.SetDrawerItems, dispatch)
    };
};

export default
    RouterHoc<ICommitteeRegularInviteesPageParams, CommitteeRegularInviteesPageProps>((connect(mapStateToProps, mapDispatchToProps)(CommitteeRegularInviteesPage) as unknown as ComponentType<CommitteeRegularInviteesPageProps>)) as ComponentType<any>;


